import React from "react";
import { Box } from "@mui/material";
import AttachmentsTable from "./ScopeTable";

export default function AttachmentsTab() {
  return (
    <Box>
      <AttachmentsTable />
    </Box>
  );
}
